"use strict";

exports.__esModule = true;
exports.default = void 0;

var _styles = require("@material-ui/core/styles");

const theme = (0, _styles.createMuiTheme)({
  typography: {
    fontFamily: "Akkurat, sans-serif !important"
  },
  overrides: {
    MuiButtonGroup: {
      grouped: {}
    },
    MuiButton: {
      root: {
        fontFamily: "Akkurat, sans-serif",
        fontWeight: "bold",
        textTransform: "none",
        borderRadius: 1
      },
      outlined: {}
    }
  }
});
var _default = theme;
exports.default = _default;
module.exports = exports.default;